import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface VerificationStore {
    hasPendingVerificationError: boolean;
    setHasPendingVerificationError: (val: boolean) => void;
}

export const useVerification = create<VerificationStore>()(
    devtools(
        immer((set, _) => ({
            hasPendingVerificationError: false,
            setHasPendingVerificationError: (val: boolean) => {
                set({ hasPendingVerificationError: val });
            },
        })),
    ),
);
